import { DEFAULT_EMPTY_VALUE } from '@/utils/constants';

/**
 * Enriches the `processInstance` row from getDetails for ListDetails (in-app navigation via history.push).
 */
export function applyProcessInstanceDetailRow(details, item, history) {
  const pid = item?.processInstance?.id;
  if (!details?.length || !pid || !history?.push) {
    return details;
  }

  const url = `/applications/${pid}`;
  const text = item.processInstance.name || DEFAULT_EMPTY_VALUE;

  return details.map((field) => {
    if (field.name !== 'processInstance' || field.type !== 'link') {
      return field;
    }

    return {
      ...field,
      url,
      text,
      onClick: (e) => {
        e.preventDefault();
        history.push(url);
      },
    };
  });
}
